import { ListItem } from './lists.model';

export class ARColzaOrganicProductType extends ListItem {}

export class ARColzaAzoteProductType extends ListItem {}

export class ARColzaOrderType extends ListItem {}

export class ARColzaAzoteFrequency extends ListItem {}

export class ARColzaResultType extends ListItem {
  visible: boolean;
}
